export default __webpack_public_path__ + "static/media/arrow.0bb9fd04.svg";